const defaultState = {
  suggestionList: null
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case "GET_SUGGESTIONS_LIST_FULFILLED":
      return {
        ...state,
        suggestionList: action.payload,
      };
    default:
      return state;
  }
}
